import { Link } from 'gatsby';

import '../../styles/generic.css';

import { _ } from '../../utils/l10n';
import ArrowRightNeutral from '../../assets/icons/arrow-right-neutral.svg';

export interface ReadMoreLinkProps {
  /**
   * Action to be performed on click
   */
  navigateTo: string;
}

export const ReadMoreLink = (
  {
    navigateTo,
  }: ReadMoreLinkProps,
) => (
  <Link to={navigateTo} className='read-more-link'>
    {_('Read more')}
    <img
      src={ArrowRightNeutral}
      alt='arrow-right'
      className='read-more-link-icon'
    />
  </Link>
);
